import * as yup from 'yup';

export const documentCreateSchema = yup.object().shape({
  documentName: yup.string().required('Name is required field.'),
  practitionerId: yup.string(),
  userGroupAdminId: yup.string(),
});
